import Vue from 'vue'
import {
  Menu,
  MenuItem,
  MenuItemGroup,
  Popover,
  Input,
  Icon,
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Dialog,
  Tree,
  Message,
  Breadcrumb,
  BreadcrumbItem,
  Tooltip,
  Checkbox
} from 'element-ui'
import VueClipboards from 'vue-clipboards'
import App from './App'
import WpsIcon from './components/Icon'
import router from './router'
import store from './store'
import {
  i18n
} from './i18n'
import {
  dateHelper
} from '@/assets/utils'
import axios from 'axios'

Vue.config.productionTip = false

Vue.prototype.$message = Message

// axios
Vue.prototype.$axios = axios.create({
  // baseURL: 'https://proxy.wps.com:3001',
  withCredentials: true,
  responseType: 'json',
  transformResponse:[
    (data) => {
      return data
    }
  ]
})

Vue.directive('scroller', {
  inserted: function (el,binding) {
    el.addEventListener('scroll',(e) => {
      let contentHeight = el.offsetHeight || el.clientHeight
      let scrollTop = el.scrollTop
      let contentInnerHeight = el.scrollHeight
      let cb = binding.value
      if (contentInnerHeight - (scrollTop + contentHeight) >= 1 || scrollTop == 0) {
        return
      }
      cb()
    })
  }
})
Vue.prototype.$convertFileType = (filename) => {
  let idx = filename.lastIndexOf('.')
  let ext = filename.slice(idx+1)
  let name = filename.replace(`.${ext}`,'')
  let map = {
    doc: 'doc',
    docx: 'doc',
    
  }
  switch (key) {
    case value:
      
      break;
  
    default:
      break;
  }
}


Vue.prototype.$relative = (difference) => {
  let text,time
  if (dateHelper.isMonmentAgo(difference)) {
    text = 'Recently'
    time = 0
  } else if (dateHelper.isSameHour(difference)) {
    text = 'Minago'
    time = dateHelper.minutesFromNow(difference)
  } else if (dateHelper.hoursFromNow(difference) <= 24) {
    text = 'Hourago'
    time = dateHelper.hoursFromNow(difference)
  } else if (dateHelper.daysFromNow(difference) <= 30) {
    text = 'Dayago'
    time = dateHelper.daysFromNow(difference)
  } else if (dateHelper.mouthsFromNow(difference) < 12) {
    text = 'Monthago'
    time = dateHelper.mouthsFromNow(difference) 
  } else {
    text = 'Yearago'
    time = Math.floor((difference) / 31536000000)
  }

  return {text,time}
}

let componentsList = [Menu, MenuItem, MenuItemGroup, Popover, Input, Icon, Button, Dropdown, DropdownItem, DropdownMenu, Dialog, Tree, Breadcrumb, BreadcrumbItem, VueClipboards, Tooltip, Checkbox]
componentsList.map(item => {
  Vue.use(item)
})
Vue.component('wps-icon',WpsIcon)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js